(() => {
  if (window.pmUxBrowseReady) return;
  window.pmUxBrowseReady = true;
  const desktop = window.matchMedia('(min-width: 750px)');
  const destinationKey = 'purefect:catalog-destination:v1';

  function initialize() {
    const toolbar = document.querySelector('.pm-collection-toolbar');
    const grid = document.getElementById('ProductGridContainer');
    if (!toolbar || !grid || toolbar.dataset.pmUxBrowseReady) return;
    toolbar.dataset.pmUxBrowseReady = 'true';

    const results = document.createElement('p');
    results.className = 'pm-ux-browse-results';
    results.setAttribute('aria-hidden', 'true');
    toolbar.after(results);
    const search = toolbar.querySelector('input[type="search"]');
    const arrangeCardActions = () => {
      grid.querySelectorAll('.card-wrapper').forEach(card => {
        const action = card.querySelector('.quick-add.pm-quick-add');
        const media = card.querySelector('.card__media > .media');
        if (!action || !media) return;
        const content = card.querySelector('.card > .card__content');
        const info = content?.querySelector('.card__information');
        if (!content || !info) return;
        card.classList.add('pm-card-refined');
        let target = content.querySelector('.pm-card-purchase');
        if (!target) {
          target = document.createElement('div');
          target.className = 'pm-card-purchase';
          const price = info.querySelector('.price');
          if (price) target.append(price);
          content.append(target);
          const portion = info.querySelector('.pm-card-portion');
          const heading = info.querySelector('.card__heading');
          if (portion && heading) info.insertBefore(portion, heading);
        }
        if (action.parentElement !== target) target.append(action);
        card.classList.add('pm-ux-actions-ready');
      });
    };
    desktop.addEventListener('change', arrangeCardActions);
    let frame;
    const updateCount = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => requestAnimationFrame(() => {
        const cards = [...grid.querySelectorAll('#product-grid > [data-pm-product-title]')];
        const count = cards.filter(card => !card.hidden).length;
        const query = search?.value.trim();
        results.textContent = `${count} ${count === 1 ? 'dish' : 'dishes'}${query ? ` matching “${query}”` : ' to choose from'}`;
        arrangeCardActions();
      }));
    };
    toolbar.addEventListener('input', updateCount);
    toolbar.addEventListener('reset', updateCount);
    grid.addEventListener('click', updateCount);
    new MutationObserver(updateCount).observe(grid, { childList: true, subtree: true });
    updateCount();

    toolbar.querySelectorAll('.pm-toolbar-categories a[href]').forEach(link => {
      link.addEventListener('click', event => {
        if (!desktop.matches || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const target = new URL(link.href, location.href);
        if (target.origin !== location.origin) return;
        try { sessionStorage.setItem(destinationKey, JSON.stringify({ path: target.pathname, at: Date.now() })); } catch (_) {}
      });
    });

    if (!desktop.matches) return;
    let destination;
    try {
      destination = JSON.parse(sessionStorage.getItem(destinationKey) || 'null');
      sessionStorage.removeItem(destinationKey);
    } catch (_) {}
    if (!destination || destination.path !== location.pathname || Date.now() - destination.at > 60000) return;
    let cancelled = false;
    const cancelEvents = ['pointerdown', 'touchstart', 'wheel', 'keydown'];
    const cancel = () => {
      cancelled = true;
      cancelEvents.forEach(name => window.removeEventListener(name, cancel));
    };
    cancelEvents.forEach(name => window.addEventListener(name, cancel, { passive: true, once: true }));
    const align = () => {
      if (cancelled) return;
      const header = document.querySelector('.section-header, #shopify-section-header');
      const top = (header?.getBoundingClientRect().height || 70) + 14;
      window.scrollTo({ top: Math.max(0, toolbar.getBoundingClientRect().top + window.scrollY - top), behavior: 'instant' });
    };
    requestAnimationFrame(align);
    window.addEventListener('load', align, { once: true });
    document.fonts?.ready.then(align);
    window.setTimeout(cancel, 2000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
